import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-inline-warning",
    styleUrls: ["./inline-warning.component.scss"],
    templateUrl: "./inline-warning.component.html",
    standalone: false
})
export class FUIInlineWarningComponent {
    @Input() title: string;
    @Input() titleParams: any = {};
    @Input() message: string;
    @Input() messageParams: any = {};
}
